import customConnect from '../customConnect';
import industries, { CAT_NAMES, VALUE_FIELD } from './mapDataMap';
import { getActiveIndustries, getColorMap } from './reducer';
import { map } from '../map/map';
import { setPopup } from '../popup/actions';
import { slide } from '../pointSizeSlider/actions';

const generateEntryProps = (props, addAddress = false) => {
	var result = [
    	{ value: props['nosaukums1']},
    ];

    if (addAddress) {
        result.push({value: props['address']});
    }

    return result;
}

const groupByProperty = (array, property) => {
	let result = {};

	for (let i = 0; i < array.length; i++) {
		if (!result[array[i][property]]) result[array[i][property]] = [];

		result[array[i][property]].push(array[i]);
	}

	return result;
}

const LAYERS = [CAT_NAMES[0], CAT_NAMES[1], CAT_NAMES[2], CAT_NAMES[3]];

export default function (store) { //new props and action function

	var ind = new industries({map});

	const mapStateToPropsRes = (state) => {
        const activeLayers = getActiveIndustries(state).filter((entry) => {
            return (LAYERS.indexOf(entry) !== -1);
        });

		return {
			activeIndustries: activeLayers,
			colorMap: getColorMap(state),
			radiusMod: state.pointSizeSlider.percent / 100
		}
	}

	const mapDispatchToPropsRes = (dispatch) => {

	  return {
	    selectFeature: (data, group, zoomLvl) => {
	    	if (data.length >= 1) {
	    		var subData = [];

				data.sort((a, b) => {
					const nameA = a.nosaukums1.normalize('NFD').toUpperCase();
					const nameB = b.nosaukums1.normalize('NFD').toUpperCase();

					if (nameA < nameB) return 1;
					if (nameA > nameB) return -1;
					return 0;
				});

                let address = '';
                let isTheSame = true;
				const isGroupedValue = data.length == 1 && !data[0].address && !data[0].nosaukums1;

	    		for (let i = data.length - 1; i >= 0; i--) {
                    const props = data[i];
                    if (address !== '' && props.address != address) {
                        isTheSame = false;
                    }

                    address = props.address;
                }

				if (isTheSame && !isGroupedValue) {
					for (let i = data.length - 1; i >= 0; i--) {
						const props = data[i];
						subData.push(generateEntryProps(props, !isTheSame));
					}
				}

				let peopleCount = data.length;

				if (isGroupedValue) {
					peopleCount = data[0].count;
				}

                let popupData = [
	    			{name: 'Deportēto skaits', value: peopleCount},
	    			{childs: subData}
	    		];

				if (!isTheSame && data[0].label == '') {
					const addressGroups = groupByProperty(data, 'address');

					for (const group in addressGroups) {
						let people = [];

						for (let i = addressGroups[group].length - 1; i >= 0; i--) {
							people.push(generateEntryProps(addressGroups[group][i], false));
						}

						popupData.push({ name: group, value: addressGroups[group].length });
						popupData.push({ childs: people });
					}
                }

                if (isTheSame && !isGroupedValue) {
                    popupData.unshift({value: data[0].address});

				} else if (data[0].label != '') {
					popupData.unshift({value: data[0].label});
				}

	    		dispatch(setPopup(popupData, ''));

	    	} else {
	    		dispatch(setPopup([]));
	    	}

	    },
	    pieSizeCallback: (topRadius, customSlideValue) => {
			if (customSlideValue != null) {
				dispatch(slide(customSlideValue));
				return;
			}

			const zoom = map.getView().getZoom();
			let zoomMod = 1;

			let koef = topRadius / 100;

			if (zoom <= 9) {
				zoomMod = 0.5;

			} else if (zoom >= 10 && zoom <= 12) {
				zoomMod = 0.8;

			} else if (zoom == 13) {
				zoomMod = 0.9;

			} else {
				zoomMod = 0.2;
			}

			let slideValue = 100 / koef * zoomMod;

			if (slideValue > 100){
				slideValue = 100;
			}

			dispatch(slide(slideValue));
	    }
	  }
	}

	customConnect(mapStateToPropsRes, mapDispatchToPropsRes, store, ind.stateUpdateHandler);
}



// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/mapData/mapContainer.js